import React from 'react';
import Summary from './Tables/Summary';
import DailyProcurement from './Tables/ProcurementByDay';
import DailyProcurement3 from './Tables/ProcurementByDay3';
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
import { startOfWeekMon, endOfWeekSun, tomorrow, shiftWeek, shiftWeekMonToSun } from "../../utils/dateFunctions";
import DateSelector from "../../shared/DateSelector";
import WarehouseSelector from "../../components/WarehouseSelector";
import PurchaseOrders from './Tables/PurchaseOrders';
import { GetAllCacheData, addToCache } from '../../utils/cacheFunctions';
import { checkAccess } from '../../utils/roleFunctions';
import { ACCESS, ACCESS_SECTIONS } from '../../utils/constants/access';
import { userInfo } from '../../../adalConfig';

const ProcurementDashboard = (props) => {
    const [startDate, setStartDate] = React.useState((startOfWeekMon(new Date())));
    const [endDate, setEndDate] = React.useState((endOfWeekSun(new Date())));
    const startDateMemo = React.useMemo(() => (startDate));
    const endDateMemo = React.useMemo(() => ((endDate)));
    const [location, setLocation] = React.useState(0);
    const [exReload, setExReload] = React.useState(false);
    const [inUse, setInUse] = React.useState(false);
    const [useNewReport, setUseNewReport] = React.useState(false);
    const canUseNewReport = checkAccess(props.access, { key: ACCESS_SECTIONS.PROCUREMENT, value: ACCESS.VIEW });
    const reportModeCacheName = `poSummaryReportMode-${userInfo()?.userName || 'default'}`;
    let timer;
    React.useEffect(() => {
        if (canUseNewReport) {
            GetAllCacheData(setUseNewReport, reportModeCacheName);
        }
    }, [canUseNewReport, reportModeCacheName]);

    React.useEffect(() => {
        if (!inUse) {
            reloadFunc();
        } else {
            clearInterval(timer);
        }

        return () => clearInterval(timer);
    }, [inUse]);

    const reloadFunc = () => {
        timer = !timer && setInterval(() => {
            console.log('TIMER')
            setExReload(stat=>!stat);
        }, 120000)
    }

    const nextWeekfunc = () => {
        var newDates = shiftWeekMonToSun(startDate, 1);
        setStartDate(newDates.start);
        setEndDate(newDates.end);
    }
    const lastWeekfunc = () => {
        var newDates = shiftWeekMonToSun(startDate, -1);
        setStartDate(newDates.start);
        setEndDate(newDates.end);
    }

    return (<div onMouseOver={() => { return !inUse ? setInUse(true) : null; }} onMouseLeave={() => { return inUse ? setInUse(false) : null; }}>
        <Grid container spacing={2} mb={1} >
            <Grid item xs={6} sm={6} md={6} lg={6} xl={3}>
                <DateSelector minDate={'2025-05-01'} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} montosun/>
            </Grid>
            {canUseNewReport ? <Grid item xs={6} sm={6} md={6} lg={6} xl={9} style={{ textAlign: 'right' }}>
                <FormControlLabel
                    control={<Switch checked={useNewReport} onChange={(event) => { addToCache(event.target.checked, reportModeCacheName); setUseNewReport(event.target.checked); }} />}
                    label="Use new PO Summary"
                />
            </Grid> : null}
            {/* <Grid item xs={6} sm={6} md={6} lg={6}>
                <WarehouseSelector location={location} setLocation={setLocation} />
            </Grid> */}
        </Grid>
        <Grid container spacing={3.5}>
            {/*<Grid item xs={12}>*/}
            {/*    <Summary location={location} startDate={startDateMemo} endDate={(endDateMemo)} externalReload={exReload} />*/}
            {/*</Grid>*/}
            <Grid item xs={12}>
                {useNewReport && canUseNewReport
                    ? <DailyProcurement3 nextWeek={nextWeekfunc} lastWeek={lastWeekfunc} location={location} startDate={startDateMemo} endDate={(endDateMemo)} externalReload={exReload} />
                    : <DailyProcurement nextWeek={nextWeekfunc} lastWeek={lastWeekfunc} location={location} startDate={startDateMemo} endDate={(endDateMemo)} externalReload={exReload} />}
            </Grid>
            {/*<Grid item xs={12}>*/}
            {/*    <PurchaseOrders nextWeek={nextWeekfunc} lastWeek={lastWeekfunc} location={location} startDate={startDateMemo} endDate={(endDateMemo)} dashboard dayToggle externalReload={exReload} />*/}
            {/*</Grid>*/}
            {/*<Grid item xs={12}>*/}
            {/*    <Transfers location={location} startDate={startDateMemo} endDate={(endDateMemo)} externalReload={exReload} />*/}
            {/*</Grid>*/}
        </Grid>
    </div >);

};



export default ProcurementDashboard;
